import React from "react";
import { Input, Table, message, Tooltip, InputNumber, Form, Divider } from "antd";
import { backendPostWithoutRefresh } from "../../../helpers/callBackend";
import GenericModal from "../../buttons/genericModal";
import { toPrice } from "../../../helpers/stringFormat";
import Button from '@mui/material/Button';

export default class SplitPaymentModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      bankAccountId: this.props.bankAccountId,
      originalTransactionId: this.props.selectedTransaction.id,
      originalTransactionDescription: this.props.selectedTransaction.description,
      originalTransactionDate: this.props.selectedTransaction.timestamp,
      originalTransactionCounterpartyName: this.props.selectedTransaction.counterparty_name,
      originalTransactionMethod: this.props.selectedTransaction.transaction_code,
      splitTransactions: [
        {
          key: 0,
          description: this.props.selectedTransaction.description,
          amount: this.props.selectedTransaction.amount,
        }
      ],
      currentSum: this.props.selectedTransaction.amount,
      updatedCount: 0,
      newSplitTransactionsKey: 1,
    };
  }

  handleSubmit = () => {

    if (this.state.splitTransactions.length === 1) {
      message.error("Must split into multiple transactions");
      return;
    }
    // the Journal transaction
    const transactions = [{
      ...this.props.selectedTransaction,
      id: this.props.selectedTransaction.id + ".journal",
      description: "Journal",
      amount: -1 * this.props.selectedTransaction.amount,
      is_original: false,
      is_journal: true,
      is_manual: true,
    }];
    for (let i = 0; i < this.state.splitTransactions.length; i++) {
      const newRow = this.state.splitTransactions[i];
      const idSuffex = i + 1
      const newTransaction = {
        ...this.props.selectedTransaction,
        id: this.props.selectedTransaction.id + "." + idSuffex,
        amount: newRow.amount,
        description: newRow.description,
        is_original: false,
        is_manual: true,
        is_journal: false,
      }
      transactions.push(newTransaction)
    }
    const data = {
      bank_account_id: this.props.bankAccountId,
      transactions: transactions,
      original_transaction_id: this.props.selectedTransaction.id,
    }
    backendPostWithoutRefresh("/api/transactions/", data)
      .then((response) => {
        this.props.closeSplitTransactionModal();
        this.props.updateCompletedTransactions(response.data.transactions, this.props.selectedTransaction.id);
      })
      .catch((error) => {
        message.error("Something went wrong");
        console.error(error);
      });
  }

  handleCancel = () => {
    this.setState({
      splitTransactions: [
        {
          description: this.props.selectedTransaction.description,
          amount: this.props.selectedTransaction.amount,
        }
      ]
    });
    this.props.closeSplitTransactionModal();
  };

  handleAddRow = () => {
    const { splitTransactions, newSplitTransactionsKey } = this.state;
    this.setState({
      splitTransactions: [...splitTransactions, {
        key: newSplitTransactionsKey,
        description: "",
        amount: 0,
      }],
      newSplitTransactionsKey: newSplitTransactionsKey + 1,
    });
  };

  handleDeleteRow = (key) => {
    const curRowAmount = this.state.splitTransactions.find((row) => row.key === key).amount;
    const newRows = this.state.splitTransactions.filter((row) => row.key !== key);
    this.setState({
      splitTransactions: newRows,
      currentSum: this.state.currentSum - curRowAmount
    });
  };

  handleInputChange = (e, key, field) => {
    const { splitTransactions } = this.state;
    const index = splitTransactions.findIndex((row) => row.key === key);

    if (index > -1) {
      const newSplitTransactions = [...splitTransactions];

      let sum = this.state.currentSum;
      if (field === "amount") {
        let num = parseFloat(e) || 0;
        newSplitTransactions[index][field] = num;
        if (!isNaN(num)) {
          sum = this.state.currentSum + num;
        } else {
          num = 0;
        }
      }
      else {
        newSplitTransactions[index][field] = e.target.value;
      }
      this.setState({ splitTransactions: newSplitTransactions, currentSum: sum });
    }
  }

  sumOfSplitNumbers = () => {
    let sum = 0;
    this.state.splitTransactions.forEach((obj) => {
      sum += obj.amount;
    })
    return sum;
  }

  render() {

    const { splitTransactions } = this.state;
    const table_columns = [
      {
        title: "Date",
        width: "15%",
        render: (text, record) => (
          <div>{this.state.originalTransactionDate.slice(0, 10)}</div>
        )
      },
      {
        title: "TO/FROM",
        width: "15%",
        render: (text, record) => (
          <div>{this.state.originalTransactionCounterpartyName}</div>
        )
      },
      {
        title: "Description",
        dataIndex: "description",
        width: "25%",
        render: (text, record) => (
          <Input
            value={text}
            onChange={(e) => this.handleInputChange(e, record.key, "description")}
          />
        )
      },
      {
        title: "Method",
        width: "15%",
        render: (text, record) => (
          <div>{this.state.originalTransactionMethod}</div>
        )
      },
      {
        title: "Amount",
        width: "25%",
        dataIndex: "amount",
        render: (text, record) => (
          <InputNumber
            formatter={value => {
              if (value.length === 0) return '$ 0';
              return `$ ${parseFloat(value).toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            }
            parser={value => value.replace(/\$\s?|\(|\)|,/g, '')}
            style={{ width: "100%" }}
            onChange={(e) => {
              this.handleInputChange(e, record.key, "amount")
            }}
            defaultValue={text}
          />
        )
      },
      {
        title: "",
        width: "5%",
        dataIndex: "operation",
        render: (_, record) =>
          splitTransactions.length > 1 && (
            <Button sx={{ fontSize: 14, textTransform: 'none', width: '60px' }} disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary" onClick={() => this.handleDeleteRow(record.key)}>Delete</Button>
          )
      }
    ];

    return (
      <GenericModal
        visible={this.props.showSplitPaymentModal}
        showModal={this.props.showSplitPaymentModal}
        handleCancelModal={this.handleCancel}
        modalTitle="Split Transaction"
        size='lg'
      modalBody={
        <Form>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Table
              columns={table_columns}
              dataSource={this.state.splitTransactions}
              pagination={false}
              bordered
            />
            <div style={{ marginTop: "10px", marginLeft: "70%", color: this.props.selectedTransaction.amount !== this.sumOfSplitNumbers() ? 'red' : 'black' }}>
              Total: {toPrice(this.sumOfSplitNumbers())} / {toPrice(this.props.selectedTransaction.amount)}
            </div>
          </div>
          <br></br>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <Button sx={{ fontSize: 14, textTransform: 'none', width: '100px' }} disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary" onClick={this.handleAddRow}>Add Row</Button>
          </div>
          <Divider />
          <div style={{ display: "flex"}}>
            {this.sumOfSplitNumbers() !== this.props.selectedTransaction.amount ?
              (
                <div style={{ marginLeft: "auto" }}>
                  <Tooltip title={`Current must be equal to ${toPrice(this.props.selectedTransaction.amount)}`}>
                    <Button sx={{ fontSize: 14, textTransform: 'none', width: '100px' }} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary" style={{ marginRight: "20px" }} disabled={true} key="submit" type="primary" onClick={this.handleSubmit}>
                      Submit
                    </Button>
                  </Tooltip>
                </div>)
              : (
                <Button sx={{ fontSize: 14, textTransform: 'none', width: '100px' }} disableElevation fullWidth size="small" type="submit" variant="contained" color="primary" style={{ marginRight: "20px", marginLeft: "auto" }} disabled={false} key="submit" type="primary" onClick={this.handleSubmit}>
                  Submit
                </Button>)
            }
            <Button sx={{ fontSize: 14, textTransform: 'none', width: '100px' }} disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary" key="cancel" onClick={this.handleCancel}>
              Cancel
            </Button>
          </div>
        </Form>
        }
      />
    );
  }
}